// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".products-container[data-v-2b9a689e] {\n  margin-top: 30px;\n}\n.products-container.compact[data-v-2b9a689e] {\n  margin-top: 20px;\n}\n.products-inline[data-v-2b9a689e] {\n  display: flex;\n  align-items: center;\n  -moz-column-gap: 0.7rem;\n       column-gap: 0.7rem;\n}", ""]);
// Exports
module.exports = exports;
